import React, { useState } from 'react';
import { formatPercent } from 'utils';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import Icons from 'components/Icons';
import { Tooltip } from '@material-ui/core';
import TextInput from 'components/TextInput/TextInput';

interface NonReduxEditablePercentProps {
  name: string;
  defaultValue: string;
  value: any;
  onChange?: Function;
  isEditable: boolean;
}

const NonReduxEditablePercent = ({
  defaultValue,
  value,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onChange = () => {},
  isEditable
}: NonReduxEditablePercentProps) => {
  const [isEditing, setIsEditing] = useState(!!value);
  const formattedDefaultValue = isNaN(parseFloat(defaultValue))
    ? defaultValue
    : formatPercent(Number(defaultValue) * 100);
  const formattedValue = formatPercent(Number(value) * 100);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '0.25rem',
        width: '100%'
      }}
    >
      {!isEditing || !isEditable ? (
        <>
          <div style={{ flex: 1 }}>{formattedDefaultValue}</div>
          {isEditable && (
            <Icons.Edit
              onClick={() => setIsEditing(true)}
              style={{ cursor: 'pointer', color: '#000' }}
            />
          )}
        </>
      ) : (
        <>
          <TextInput label="" value={formattedValue} onChange={onChange} />
          <Tooltip
            title={`Revert to original value: ${formattedDefaultValue}`}
            arrow
          >
            <CloseRoundedIcon
              style={{ height: '24px' }}
              onClick={() => {
                setIsEditing(false);
                onChange(formatPercent(Number(defaultValue) * 100));
              }}
            />
          </Tooltip>
        </>
      )}
    </div>
  );
};

export default NonReduxEditablePercent;
